import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as DeletedTasksActions from './deleted-task.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class DeletedTasksStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.DELETED_TASKS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new DeletedTasksActions.DeletedTasksCreate(data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new DeletedTasksActions.DeletedTasksDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new DeletedTasksActions.DeletedTasksRefresh(data.id));
          break;
      }
    });
  }
}
